import React, { useState, useEffect, useCallback, useRef } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { GoogleMap, useLoadScript, Marker, Autocomplete } from "@react-google-maps/api";
import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useParams, Link } from "react-router-dom";
import Select, { SingleValue } from "react-select";
import { License, Office, Agent, Address, Product, PaymentMethod, PaymentGateway, StatusHistoryItem, PaymentInfoItem } from "types";
import { sub } from "date-fns";
import { to } from "assets/libs/moment/src/lib/moment/to";
import { Button } from "react-bootstrap";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe, Stripe } from "@stripe/stripe-js";
import PaymentFormManualOrder from "../../components/PaymentFormManualOrder";
import { from } from "assets/libs/moment/src/lib/moment/from";
import { getAuthCookie } from "../../utils/authCookies";


type ProductObj = {
    product_id: string;
    agent_id: string;
    office_id: string;
    inventory_type: string;
    product: Product;
    created_by: {
        id: string;
        name: string;
    };
};

type Selected = {
    value: string;
    label: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
}

const libraries: Array<"places"> = ["places"];
const apiKey: string = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";

const mapContainerStyle = {
    width: "100%",
    height: "400px",
};

const center = {
    lat: 40.712776, // Default latitude (e.g., New York City)
    lng: -74.005974, // Default longitude
};

const SignageTeammemberViewInstallation = () => {
    const mapRef = useRef<google.maps.Map | null>(null);
    const { installationId } = useParams<{ installationId: string }>();
    const token = getAuthCookie("sessionToken");
    const userId = getAuthCookie("userId");
    const userName = getAuthCookie("userName");
    const [brokerageFirms, setBrokerageFirms] = useState<License[]>([]);
    const [teamMembers, setTeamMembers] = useState<any[]>([]);
    const [selectedTeamMember, setSelectedTeamMember] = useState<any | null>(null);
    const [installer, setInstaller] = useState<any[]>([]);
    const [offices, setOffices] = useState<Office[]>([]);
    const [officeAgents, setOfficeAgents] = useState<Agent[]>([]);
    const [agents, setAgents] = useState<Agent[]>([]);
    const [preview, setPreview] = useState<string | null>(null);
    const [error, setError] = useState<string>("");
    const [loading, setLoading] = useState(true);
    const [formSubmitting, setFormSubmitting] = useState(false);
    const [uploadProgress, setUploadProgress] = useState<number>(0);
    const [quantity, setQuantity] = useState(1);
    const [addressObjects, setAddressObjects] = useState<any[]>([]);
    const [showAllocateModal, setShowAllocateModal] = useState(false);
    const [showViewInventoryModal, setShowViewInventoryModal] = useState(false);
    const [installationOrder, setInstallationOrder] = useState<any>();

    const [createSignage, setCreateSignage] = useState<License>();
    const [productObjs, setProductObjs] = useState<ProductObj[]>([]);
    const [selectedProductOption, setSelectedProductOption] = useState<any | null>(null);
    const [selectedProducts, setSelectedProducts] = useState<any[]>([]);
    const [installationCost, setInstallationCost] = useState<number | null>(null);
    const [scheduledJobsCount, setScheduledJobsCount] = useState<number | null>(null);
    const [totalUnits, setTotalUnits] = useState<number>(0);
    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
    const [uploadedFileMeta, setUploadedFileMeta] = useState<any[]>([]);
    const [imagePreviews, setImagePreviews] = useState<string[]>([]);
    const [previewFiles, setPreviewFiles] = useState<{ file: File; url: string }[]>([]);
    const [openStatusIndex, setOpenStatusIndex] = useState<number | null>(null);
    const [openProductStatusIndex, setOpenProductStatusIndex] = useState<number | null>(null);
    const [installationLocations, setInstallationLocations] = useState<any[]>([]);
    const [paymentMethod, setPaymentMethod] = useState<PaymentMethod[]>([]);
    const [payment, setPayment] = useState(false);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<string>("");
    const [rotationalPoolProducts, setRotationalPoolProducts] = useState<any[]>([]);
    const [selectedProduct, setSelectedProduct] = useState<any | null>(null);
    const [warehouseOptions, setWarehouseOptions] = useState<any[]>([]);
    const [selectedWarehouse, setSelectedWarehouse] = useState<any | null>(null);
    const [availableSerializedUnits, setAvailableSerializedUnits] = useState<any[]>([]);
    const [allocatedUnits, setAllocatedUnits] = useState<{
        [linkedProductId: string]: {
            rotationalProductId: string;
            warehouseId: string;
            serial_id: string;
            serial_number: string;
            product_name: string;
            sku: string;
        }[];
    }>({});

    const [linkedProductIdContext, setLinkedProductIdContext] = useState<string | null>(null);

    const navigate = useNavigate();

    const { isLoaded } = useLoadScript({
        googleMapsApiKey: apiKey,
        libraries,
    });

    const [address, setAddress] = useState("");
    const autocompleteRef = useRef<google.maps.places.Autocomplete | null>(null);

    const [selectedLocation, setSelectedLocation] = useState<{
        lat: number;
        lng: number;
    } | null>(null);

    const [selectedBrokerageFirm, setSelectedBrokerageFirm] = useState<Selected | null>(null);

    const [selectedOffice, setSelectedOffice] = useState<Selected | null>(null);

    const [selectedOfficeAgent, setSelectedOfficeAgent] = useState<Selected | null>(null);

    const [selectedInstaller, setSelectedInstaller] = useState<Selected | null>(null);

    const [selectedAgent, setSelectedAgent] = useState<Selected | null>(null);

    const [selectedBillingAddress, setSelectedBillingAddress] =
        useState<Address | null>(null);
    const [selectedOfficeBillingAddress, setSelectedOfficeBillingAddress] =
        useState<Address | null>(null);

    const [installationAddress, setInstallationAddress] = useState<Address>();

    const buyerOptions: { value: string; label: string }[] = [
        { value: "brokerageFirm", label: "Brokerage Firm" },
        { value: "agent", label: "Agent" },
    ];

    const brokerageOptions = brokerageFirms?.map((office) => ({
        value: office.id,
        label: office?.firmDetails?.companyName + "(" + office?.firstName + ")",
        firstName: office?.firstName,
        lastName: office?.lastName,
        email: office?.email,
        phone: office?.phone1,
    }));

    const teamMemberOptions = teamMembers?.map((member) => ({
        value: member.id,
        label: `${member.firstName} ${member.lastName}`,
        email: member.email,
    }));

    const officeOptions = offices?.map((office) => ({
        value: office?._id,
        label: office?.officeName,
        firstName: office?.officeName,
        lastName: office?.officeName,
        email: "",
        phone: office?.officeAddress?.[0]?.phone,
    }));

    const officeAgentOptions = officeAgents?.map((agent) => ({
        value: agent.id,
        label: agent.firstName + " " + agent.lastName,
        firstName: agent.firstName,
        lastName: agent.lastName,
        email: agent.email,
        phone: agent.phone1,
    }));

    const agentOptions = agents?.map((agent) => ({
        value: agent.id,
        label: agent.firstName + " " + agent.lastName,
        firstName: agent.firstName,
        lastName: agent.lastName,
        email: agent.email,
        phone: agent.phone1,
    }));

    const productOptions = productObjs?.map((item) => ({
        value: item.product_id,
        label: item.product.name,
    }));

    const priorityOptions = [
        { value: 1, label: "High" },
        { value: 2, label: "Medium" },
        { value: 3, label: "Low" },
    ];

    useEffect(() => {
        return () => {
            if (preview) URL.revokeObjectURL(preview);
        };
    }, [preview]);

    useEffect(() => {
        const fetchLicense = async () => {
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_API_URL}/users/${userId}`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error("Failed to fetch license data");
                }

                const data = await response.json();
                console.log("Create Signage Data:", data);
                if (data) {
                    setCreateSignage(data);
                }

            } catch (error) {
                console.error("Error fetching license data:", error);
                setError("Failed to fetch license data.");
            } finally {
                setLoading(false);
            }
        };

        if (!createSignage) {
            fetchLicense();
        }
    }, [userId, token]);

    useEffect(() => {
        // console.log("Installation ID:", installationId);
        const fetchOrderDetails = async () => {
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_API_URL}/installation_orders/${installationId}`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                const data = await response.json();
                console.log("Installation Orders:", data);
                if (!response.ok) throw new Error(data.message || "Failed to fetch order details");

                setInstallationOrder(data);
            } catch (err: any) {
                console.error("Order Detail Fetch Error:", err.message);
            }
        };

        fetchOrderDetails();
    }, [installationId, token]);

    useEffect(() => {
        if (installationOrder) {
            const addr = installationOrder?.installation_details?.installation_address;
            setInstallationAddress(addr);
        }
    }, [installationOrder]);


    const fetchBrokerageFirms = async (userType: string) => {
        formik.setFieldValue("userType", userType);
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/brokerage-firms`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            const data = await response.json();
            console.log("fetchBrokerageFirms data :", data);

            if (!response.ok) {
                // throw new Error("Failed to fetch agents");
                toast.error(data.error || "Failed to fetch firms");
            }

            setBrokerageFirms(data);
        } catch (err) {
            setError(
                err instanceof Error ? err.message : "An unknown error occurred"
            );
        } finally {
            setLoading(false);
        }
    };

    const featchBrokerageTeammembers = async (brokerage: any) => {
        setSelectedBrokerageFirm(brokerage);
        console.log("selectedBrokarageFirms:", brokerage);
        let brokerageId = brokerage?.value;

        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/users-search?created_by.id=${brokerageId}&licenseType=BROKERAGE_TEAM_MEMBER`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            const data = await response.json();
            console.log("featchBrokerageTeammembers :", data);

            if (!response.ok) {
                toast.error(data.error || "Failed to fetch offices");
            } else {
                setTeamMembers(data);
                const normalizedOffices = data.flatMap((member: any) =>
                    (member.offices || []).map((office: any) => ({
                        _id: office._id,
                        officeName: office.officeName,
                        officeType: office.officeType,
                        officeAddress: [office.officeAddress], // ✅ wrap in array to match expected type
                    }))
                );

                setOffices(normalizedOffices);
                console.log("offices :", normalizedOffices);
                // ✅ Set selectedOffice based on installationOrder
                if (installationOrder?.office?._id && normalizedOffices.length > 0) {
                    const matchedOffice = normalizedOffices.find(
                        (office: any) => office._id === installationOrder.office._id
                    );
                    if (matchedOffice) {
                        const officeOption = {
                            value: matchedOffice._id,
                            label: matchedOffice.officeName,
                            firstName: matchedOffice.officeName,
                            lastName: matchedOffice.officeName,
                            email: "",
                            phone: matchedOffice.officeAddress?.[0]?.phone || "",
                        };
                        setSelectedOffice(officeOption);
                        fetchLinkedProducts("office", officeOption.value);
                        fetchOfficeAgents(officeOption);
                    }
                }
            }
        } catch (err) {
            setError(
                err instanceof Error ? err.message : "An unknown error occurred"
            );
        } finally {
            setLoading(false);
        }
    };


    const fetchOfficeAgents = async (office: any) => {
        setSelectedOffice(office);
        console.log("selectedOffices In fetchOfficeAgents:", office);
        let officeId = office?.value;

        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/agent/office/${officeId}`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            const data = await response.json();
            console.log("officeAgents :", data);

            if (!response.ok) {
                toast.error(data.error || "Failed to fetch agents");
            } else {
                setOfficeAgents(data);
            }
        } catch (err) {
            setError(
                err instanceof Error ? err.message : "An unknown error occurred"
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const fetchAgents = async () => {
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_API_URL}/users/signage/${userId}/agents`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error("Failed to fetch agents");
                }

                const data: Agent[] = await response.json();
                // console.log("signage agents :", data);
                setAgents(data);
            } catch (err) {
                setError(
                    err instanceof Error ? err.message : "An unknown error occurred"
                );
            } finally {
                setLoading(false);
            }
        };

        fetchAgents();
    }, [token]);

    const fetchUserAddresses = async (user: any) => {
        console.log("fetchUserAddresses IN")
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/user-addresses/${user?.value}`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            const data = await response.json();
            console.log("user addresses :", data);
            // setAddresses(data.addresses);
            setAddressObjects(data);
        } catch (err) {
            setError(
                err instanceof Error ? err.message : "An unknown error occurred"
            );
        } finally {
            setLoading(false);
        }
    };

    const fetchOfficeAddresses = async (office: any) => {
        console.log("fetchOfficeAddresses IN")
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/offices/${office?.value}`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            const data = await response.json();
            console.log("office addresses :", data.officeAddress);
            setAddressObjects(data.officeAddress);
        } catch (err) {
            setError(
                err instanceof Error ? err.message : "An unknown error occurred"
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (selectedOfficeAgent) {
            fetchUserAddresses(selectedOfficeAgent);
        } else if (selectedAgent) {
            fetchUserAddresses(selectedAgent);
        } else if (selectedOffice) {
            fetchOfficeAddresses(selectedOffice);
        }
    }, [selectedAgent, selectedOfficeAgent, selectedOffice, token]);

    const addressOptions =
        addressObjects !== null
            ? addressObjects?.map((address) => ({
                ...address,
                value: address._id,
                label: address.label,
            }))
            : [];

    const fetchLinkedProducts = async (
        userType: "agent" | "office",
        user_Id: string,
    ) => {
        console.log("fetchLinkedProducts IN");
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/inventory/${userType}/${user_Id}/signage/${createSignage?.created_by?.id}`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            const data = await response.json();
            console.log("Linked Products:", data);
            setProductObjs(data);

            if (!response.ok) {
                toast.error(data?.error || "Failed to fetch linked products");
            } else {
                // setLinkedProducts(data); if needed
            }
        } catch (err) {
            setError(err instanceof Error ? err.message : "Unknown error occurred");
        }
    };

    // based on installation Address we are calling the dyniamc cost
    useEffect(() => {
        const fetchInstallationCost = async () => {
            if (
                !installationAddress?.latitude ||
                !installationAddress?.longitude ||
                installationAddress.latitude === 0 ||
                installationAddress.longitude === 0
            ) {
                toast.warning(
                    "Selected installation address is missing latitude/longitude. Please enter the address manually."
                );
                return;
            }

            try {
                const response = await fetch(
                    `${process.env.REACT_APP_API_URL}/installation_orders/dynamic_cost/${createSignage?.created_by?.id}`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                        },
                        body: JSON.stringify({
                            installation_address: {
                                addressLine1: installationAddress.addressLine1,
                                addressLine2: installationAddress.addressLine2,
                                city: installationAddress.city,
                                state: installationAddress.state,
                                country: installationAddress.country,
                                zip: installationAddress.zip,
                                cityCode: installationAddress.cityCode,
                                stateCode: installationAddress.stateCode,
                                countryCode: installationAddress.countryCode,
                                latitude: installationAddress.latitude,
                                longitude: installationAddress.longitude,
                            }
                        }),
                    }
                );

                const data = await response.json();
                console.log("Installation cost:", data);
                if (!response.ok) throw new Error(data?.error || "Failed to fetch cost");

                setInstallationCost(data.cost || 0); // adjust based on response shape
            } catch (error: any) {
                console.error("Cost fetch error:", error.message);
                setInstallationCost(null);
            }
        };
        if (installationAddress) {
            fetchInstallationCost();
        }
    }, [installationAddress, token]);


    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            userType: installationOrder?.user_type,
            userFirstName: "",
            userLastName: "",
            userEmail: installationOrder?.user_email,
            userPhone: installationOrder?.user_phone,
            brokerageFirmsId: installationOrder?.brokerage_firm_id,
            teamMemberId: installationOrder?.team_member_id,
            company: "",
            office: installationOrder?.office,
            agent: installationOrder?.agent_id,
            scheduled_date: installationOrder?.installation_details?.scheduled_date?.split("T")[0] || "",
            jobs_today: 0,
            installeId: installationOrder?.installation_details.installer_id,
            priority: installationOrder?.priority,
            billing_address: installationOrder?.billing_address,
            installation_address: installationOrder?.installation_details.installation_address,
            isSameAsBilling: true,
            billingAddressId: installationOrder?.billing_address._id,
            installationAddressId: installationOrder?.installation_details.installation_address._id,
            location: "",
            products: "",
            instructions: "",
            payment_method: "",
            image: null,
            installation_charge: installationOrder?.installation_cost,
            discount: installationOrder?.discount_amount || 0,
            subtotal: installationOrder?.subtotal_amount,
            total: installationOrder?.total_amount,
            tax: 0,
            enable_partial_payment: false,
            partial_amount: 0,
            transactionId: "",
            paymentMethod: "",
        },
        validationSchema: Yup.object({
            // installer: Yup.string().required("Installer is required"),
            // installation_date: Yup.string().required("Installation date is required"),
            // billing_address: Yup.string().required("Billing address is required"),
            // installation_address: Yup.string().required(
            //   "Installation address is required"
            // ),
            // image: Yup.mixed().required("Image is required"),
        }),
        onSubmit: async (values) => {
            setFormSubmitting(true);
            // Example file upload handling
            const imageUrl = values.image ? await uploadFile(values.image) : null;

            // let officeInfo = null;
            // let agentId = null;
            // let sourceId = null;
            // let agentName = null
            // let customerId = null;
            // let inventorySource = "agent"; // default fallback
            // let finalBillingAddress = null;
            // let finalInstallationAddress = null;
            // if (selectedOfficeAgent) {
            //   agentId = selectedOfficeAgent?.value;
            //   sourceId = selectedOfficeAgent?.value
            //   agentName = selectedOfficeAgent?.label
            //   customerId = selectedOfficeAgent?.value;
            //   inventorySource = "agent";
            //   officeInfo = null;
            //   finalBillingAddress = selectedBillingAddress;
            //   finalInstallationAddress = installationAddress;
            // } else if (selectedAgent) {
            //   agentId = selectedAgent?.value;
            //   sourceId = selectedAgent?.value;
            //   agentName = selectedAgent?.label
            //   customerId = selectedAgent?.value;
            //   inventorySource = "agent";
            //   officeInfo = null;
            //   finalBillingAddress = selectedBillingAddress;
            //   finalInstallationAddress = installationAddress;
            // } else if (selectedOffice) {
            //   const selectedOfficeData = offices?.find(
            //     (office) => office._id === selectedOffice?.value
            //   );
            //   const primaryAddress = selectedOfficeData?.officeAddress?.[0];
            //   officeInfo = {
            //     _id: selectedOffice?.value,
            //     officeName: selectedOffice?.label,
            //     officeType: selectedOffice?.label,
            //     officeAddress: primaryAddress,
            //     status: true,
            //   };
            //   sourceId = selectedOffice?.value;
            //   inventorySource = "office";
            //   agentId = null;
            //   agentName = null
            //   finalBillingAddress = selectedOfficeBillingAddress;
            //   finalInstallationAddress = installationAddress;
            // }

            let lineItems: any[] = [];

            // 📦 1. Regular products (agent or office)
            lineItems = selectedProducts.map((product) => {
                const matched = productObjs.find((p) => p.product_id === product.product_id);
                const allocated = allocatedUnits[product.product_id] || [];

                return {
                    product_id: product.product_id,
                    inventory_source: matched?.inventory_type || "", // agent or office
                    warehouse_id: null,
                    serial_ids: [],
                    product_name: matched?.product?.name || "",
                    sku: matched?.product?.sku || "",
                    quantity: Number(product.quantity),
                    unit_price: Number(matched?.product?.retail_price || 0),
                    total_price: Number(matched?.product?.retail_price || 0) * Number(product.quantity),
                    discount: 0,
                    tax_amount: 0,
                    inventory_deducted: false,
                    fulfillment_type: "stock",
                    production_status: product.productionStatus || "not started",
                    is_rotational: matched?.product?.is_rotational || false,
                    current_status: matched?.product?.current_status || "",
                    notes: product.notes || "",
                    rotational_allocated: allocated.length, // ✅ fix here
                };
            });

            // 🔄 2. Rotational allocations
            Object.entries(allocatedUnits).forEach(([linkedProductId, units]) => {
                if (units.length === 0) return;
                lineItems.push({
                    source_product_id: linkedProductId,
                    product_id: units[0].rotationalProductId,
                    inventory_source: "rotational",
                    warehouse_id: units[0].warehouseId || "",
                    serial_ids: units.map((u) => u.serial_id),
                    serial_codes: units.map((u) => u.serial_number),
                    product_name: units[0].product_name || "",
                    sku: units[0].sku || "",
                    quantity: 1,
                    unit_price: 0,
                    total_price: 0,
                    discount: 0,
                    tax_amount: 0,
                    inventory_deducted: false,
                    fulfillment_type: "stock",
                    production_status: null,
                    is_rotational: true,
                    current_status: "",
                    notes: "",
                });
            });


            try {
                // Step 1: Run Schedule or Reschedule First
                let shouldProceed = true;

                if (installationOrder?.status === 200) {
                    shouldProceed = await handleInstallationStatus(300); // returns true/false
                }
                if (!shouldProceed) {
                    return; // ❌ Stop here
                }
                const response = await fetch(`${process.env.REACT_APP_API_URL}/installation_orders/update/${installationId}`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        // order_number: installationOrder?.order_number,
                        // inventory_source: inventorySource,
                        // source_id: sourceId,
                        // brokerage_firm_id: selectedBrokerageFirm?.value,
                        // brokerage_firm_name: selectedBrokerageFirm?.label,
                        // team_member_id: values.teamMemberId,
                        // office: officeInfo,
                        // agent_id: agentId,
                        // agent_name: agentName,
                        // signage_id: userId,
                        // signage_company_name: userName,
                        line_items: lineItems,
                        // customer_group_id: null,
                        // payment_method: values.payment_method,
                        installation_details: {
                            scheduled_date: new Date(values.scheduled_date).toISOString(),
                            installation_address: installationOrder?.installation_details?.installation_address,
                            installer_id: selectedInstaller?.value,
                            installer_name: selectedInstaller?.label,
                            contact_number: selectedInstaller?.phone,
                            estimated_duration: null,
                            actual_installation_date: null,
                            installation_notes: values.instructions,
                            assignee_id: selectedInstaller?.value,
                            tax_details: null,
                        },
                        billing_address: installationOrder?.billing_address,
                        additional_instructions: values.instructions,
                        // local_laws_compliance: true,
                        priority: values.priority,
                        uploaded_files: uploadedFileMeta || [],
                        subtotal_amount: values.subtotal,
                        installation_cost: parseFloat(String(installationCost)) || 0,
                        additional_cost: 0,
                        // tax_amount: 0,
                        discount_amount: values.discount,
                        total_amount: values.total,
                        // overpaid_amount: 0,
                        version: installationOrder?.version,
                        // tax_inclusive: false,
                        // tax_details: null,
                    }),
                });

                const data = await response.json();

                if (!response.ok) {
                    throw new Error(data.message || "Failed to create installation order");
                }

                toast.success("Installation order created successfully!");
                navigate("/signageteammember/jobs/installations");
            } catch (error: any) {
                toast.error(`Error: ${error.message}`);
            } finally {
                setFormSubmitting(false);
            }
        }
    });

    // we are fetching signage team members for showing Assigned To dropdown
    useEffect(() => {
        const featchSignageTeammembers = async () => {
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_API_URL}/users-search?created_by.id=${createSignage?.created_by?.id}&licenseType=SIGNAGE_TEAM_MEMBER`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                const data = await response.json();
                // console.log("featchSignageTeammembers:", data);

                const installers = data.map((user: any) => ({
                    value: user.id,
                    label: `${user.firstName} ${user.lastName}`,
                    firstName: user.firstName,
                    lastName: user.lastName,
                    email: user.email,
                    phone: user.phone1,
                }));

                setInstaller(installers); // 🟢 Now it's filtered and formatted
                // ✅ Set selected installer if it matches formik value
                const matchedInstaller = installers.find(
                    (option: any) => option.value === formik.values.installeId
                );
                if (matchedInstaller) {
                    setSelectedInstaller(matchedInstaller);
                    // console.log("selectedInstallar :", matchedInstaller)
                }
            } catch (err) {
                setError(err instanceof Error ? err.message : "An unknown error occurred");
            } finally {
                setLoading(false);
            }
        };

        featchSignageTeammembers();
    }, [token, userId, formik.values.installeId]);

    const uploadFile = async (file: File): Promise<string> => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("uploadDir", "installation_orders");

        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open("POST", `${process.env.REACT_APP_API_URL}/images/upload`, true);
            xhr.setRequestHeader("Authorization", `Bearer ${token}`);

            xhr.upload.onprogress = (event) => {
                if (event.lengthComputable) {
                    setUploadProgress((event.loaded / event.total) * 100);
                }
            };

            xhr.onload = () => {
                if (xhr.status === 200 || xhr.status === 201) {
                    const response = JSON.parse(xhr.responseText);
                    resolve(response.path);
                } else {
                    reject(new Error("Failed to upload file"));
                }
            };

            xhr.onerror = () => reject(new Error("Network error during file upload"));
            xhr.send(formData);
        });
    };

    const handleLocationChange = (
        selectedOption: SingleValue<{ value: string; label: string }>
    ) => {
        formik.setFieldValue("location", selectedOption?.value || "");
    };

    const handleMapClick = useCallback((event: google.maps.MapMouseEvent) => {
        if (event.latLng) {
            const lat = event.latLng.lat();
            const lng = event.latLng.lng();
            setSelectedLocation({ lat, lng });
            formik.setFieldValue("location", { lat, lng });
        }
    }, []);

    const handlePlaceChanged = () => {
        if (autocompleteRef.current) {
            const place = autocompleteRef.current.getPlace();
            console.log("Place changed:", place);

            const addressComponents = place.address_components;
            console.log(addressComponents);

            if (addressComponents) {
                const getComponent = (type: string) => {
                    const component = addressComponents?.find(c => c.types.includes(type));
                    return component ? { long_name: component.long_name, short_name: component.short_name } : { long_name: '', short_name: '' };
                };

                const streetNumber = getComponent('street_number').long_name;
                const route = getComponent('route').long_name;

                const cityObj = getComponent('locality') || getComponent('administrative_area_level_2');
                const stateObj = getComponent('administrative_area_level_1');
                const postalCode = getComponent('postal_code').long_name;
                const countryObj = getComponent('country');


                const street = `${streetNumber} ${route}`.trim();

                const latitude = place.geometry?.location?.lat();
                const longitude = place.geometry?.location?.lng();

                console.log("Latitude:", latitude, "Longitude:", longitude);

                // Update form values
                // formik.setFieldValue('streetAddress1', street);
                // formik.setFieldValue('city', cityObj.long_name);
                // formik.setFieldValue('county', cityObj.long_name);
                // formik.setFieldValue('cityCode', cityObj.short_name); // <-- Add this
                // formik.setFieldValue('state', stateObj.long_name);
                // formik.setFieldValue('stateCode', stateObj.short_name); // <-- Add this
                // formik.setFieldValue('zipcode', postalCode);
                // formik.setFieldValue('country', countryObj.long_name);
                // formik.setFieldValue('countryCode', countryObj.short_name); 

                // if (latitude && longitude) {
                //   formik.setFieldValue('latitude', latitude);
                //   formik.setFieldValue('longitude', longitude);
                // }

                const installation_address = street + ',' + cityObj.long_name + ', ' + stateObj.long_name + ', ' + postalCode;
                setInstallationAddress({
                    _id: '',
                    label: installation_address,
                    addressLine1: street,
                    addressLine2: '',
                    country: countryObj.long_name,
                    county: cityObj.long_name,
                    city: cityObj.long_name,
                    state: stateObj.long_name,
                    zip: postalCode,
                    cityCode: cityObj.short_name,
                    stateCode: stateObj.short_name,
                    countryCode: countryObj.short_name,
                    latitude: latitude || 0,
                    longitude: longitude || 0,
                    phone: '',
                });

                formik.setFieldValue('installationAddressId', installation_address);
            }
        }
    };

    // to get the scheduled job count based on the selected date
    useEffect(() => {
        const fetchScheduledJobs = async () => {
            if (!formik.values.scheduled_date || !userId) return;

            const date = new Date(formik.values.scheduled_date).toISOString().split("T")[0]; // format as YYYY-MM-DD

            try {
                const res = await fetch(
                    `${process.env.REACT_APP_API_URL}/installation_orders/${formik.values.installeId}/${date}/scheduled_jobs`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                const data = await res.json();
                if (!res.ok) throw new Error(data.message || "Failed to fetch job count");
                console.log("Scheduled Jobs:", data);

                setScheduledJobsCount(data.scheduled_jobs); // assuming response shape: { count: number }
                formik.setFieldValue("scheduled_jobs", data.scheduled_jobs);
            } catch (err: any) {
                console.error("Scheduled Jobs Error:", err.message);
                setScheduledJobsCount(null);
            }
        };

        fetchScheduledJobs();
    }, [formik.values.installeId, userId, token]);

    // seting the total units based on the selected products
    useEffect(() => {
        const newTotal = selectedProducts
            .filter((p) => p.inventory_type !== "rotational")
            .reduce((sum, product) => sum + (product.quantity || 0), 0);

        setTotalUnits(newTotal);
    }, [selectedProducts]);



    // seting the installation address based on the selected billing address
    useEffect(() => {
        if (formik.values.isSameAsBilling) {
            const isOffice = !selectedOfficeAgent && !selectedAgent && selectedOffice;
            const billing = isOffice ? selectedOfficeBillingAddress : selectedBillingAddress;

            if (billing) {
                console.log("Billing Address:", billing);
                setInstallationAddress(billing);
                formik.setFieldValue("installationAddressId", billing.label || "");
            }
        }
    }, [formik.values.isSameAsBilling, selectedBillingAddress, selectedOfficeBillingAddress]);

    // calculating the subtotal and total
    useEffect(() => {
        const subtotal = Number(installationCost) + Number(formik.values.tax);
        const total = subtotal - Number(formik.values.discount || 0);

        formik.setFieldValue("subtotal", subtotal);
        formik.setFieldValue("total", total);
    }, [installationCost, formik.values.tax, formik.values.discount]);

    // remove the preview images
    useEffect(() => {
        return () => {
            imagePreviews.forEach((url) => URL.revokeObjectURL(url));
        };
    }, [imagePreviews]);

    useEffect(() => {
        if (
            installationAddress?.latitude &&
            installationAddress?.longitude &&
            installationAddress.latitude !== 0 &&
            installationAddress.longitude !== 0
        ) {
            console.log("Setting marker from installationAddress");
            setSelectedLocation({
                lat: installationAddress.latitude,
                lng: installationAddress.longitude,
            });
        }
    }, [installationAddress]);


    const handleMarkerDragEnd = async (event: google.maps.MapMouseEvent) => {
        const lat = event.latLng?.lat();
        const lng = event.latLng?.lng();

        if (!lat || !lng) return;

        setSelectedLocation({ lat, lng });

        try {
            const geocoder = new window.google.maps.Geocoder();
            const response = await geocoder.geocode({ location: { lat, lng } });

            if (response.results[0]) {
                const place = response.results[0];
                const addressComponents = place.address_components;

                const getComponent = (type: string) => {
                    const component = addressComponents.find((c: any) =>
                        c.types.includes(type)
                    );
                    return component
                        ? { long_name: component.long_name, short_name: component.short_name }
                        : { long_name: "", short_name: "" };
                };

                const streetNumber = getComponent("street_number").long_name;
                const route = getComponent("route").long_name;
                const cityObj =
                    getComponent("locality") ||
                    getComponent("administrative_area_level_2");
                const stateObj = getComponent("administrative_area_level_1");
                const postalCode = getComponent("postal_code").long_name;
                const countryObj = getComponent("country");

                const street = `${streetNumber} ${route}`.trim();

                const newAddress = {
                    _id: "",
                    label: place.formatted_address,
                    addressLine1: street,
                    addressLine2: "",
                    country: countryObj.long_name,
                    county: cityObj.long_name,
                    city: cityObj.long_name,
                    state: stateObj.long_name,
                    zip: postalCode,
                    cityCode: cityObj.short_name,
                    stateCode: stateObj.short_name,
                    countryCode: countryObj.short_name,
                    latitude: lat,
                    longitude: lng,
                    phone: "",
                };

                setInstallationAddress(newAddress);
                formik.setFieldValue("installationAddressId", place.formatted_address);
            }
        } catch (error) {
            console.error("Geocoder failed", error);
            toast.error("Unable to update address from marker position.");
        }
    };

    const updateProductionStatus = async (productId: string, productionStatus: string) => {
        if (!installationId || !token) return;

        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/installation_orders/${installationId}/update_production_status`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        product_id: productId,
                        production_status: productionStatus,
                    }),
                }
            );

            const data = await response.json();
            console.log("updateProductionStatus:", data);

            if (!response.ok) {
                toast.error(data?.error || "Failed to update production status");
                return;
            }

            toast.success("Production status updated successfully!");
        } catch (err: any) {
            toast.error(err.message || "Error updating production status");
        }
    };

    useEffect(() => {
        const fetchInstallationLocations = async () => {
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/installation_locations`, {
                    headers: { Authorization: `Bearer ${token}` },
                });

                const data = await res.json();
                if (!res.ok) throw new Error(data.message || "Failed to load locations");
                console.log("Fetched Installation Locations:", data.locations);
                setInstallationLocations(data.locations || []);
            } catch (err: any) {
                console.error("Error loading locations:", err.message);
                toast.error("Failed to load installation markers");
            }
        };

        fetchInstallationLocations();
    }, []);

    const getInstallationLocationById = async (locationId: string) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/installation_locations/${locationId}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.message || "Failed to fetch location");

            console.log("Installation Location:", data);
            return data;
        } catch (error: any) {
            console.error("Fetch Location Error:", error.message);
            toast.error("Failed to fetch installation location.");
            return null;
        }
    };

    const handleInstallationStatus = async (nextStatus: number): Promise<boolean> => {
        if (!installationId || !token) return false;

        setLoading(true);

        try {
            let url = "";
            let body: any = undefined;

            const scheduledDate = installationOrder?.installation_details?.scheduled_date;

            switch (nextStatus) {
                case 200: // Finalize
                    url = `${process.env.REACT_APP_API_URL}/installation_orders/${installationId}/finalize`;
                    break;

                case 300: { // Schedule / Reschedule
                    const newDate = formik.values.scheduled_date;
                    // const isDateChanged = newDate && newDate !== scheduledDate?.split("T")[0];
                    // url = `${process.env.REACT_APP_API_URL}/installation_orders/${installationId}/${isDateChanged ? "reschedule" : "schedule"}`;
                    url = `${process.env.REACT_APP_API_URL}/installation_orders/${installationId}/schedule`;
                    body = {
                        installation_details: {
                            scheduled_date: new Date(newDate).toISOString(),
                            assignee_id: formik.values.installeId || undefined,
                            installer_id: selectedInstaller?.value,
                            installer_name: selectedInstaller?.label,
                        },
                        note: formik.values.instructions,
                    };
                    break;
                }

                case 400:
                    url = `${process.env.REACT_APP_API_URL}/installation_orders/${installationId}/in_progress`;
                    body = { note: formik.values.instructions };
                    break;

                case 500:
                    url = `${process.env.REACT_APP_API_URL}/installation_orders/${installationId}/complete`;
                    break;

                case 600:
                    url = `${process.env.REACT_APP_API_URL}/installation_orders/${installationId}/cancel`;
                    body = { note: formik.values.instructions };
                    break;

                default:
                    toast.error("Invalid status selected");
                    setLoading(false);
                    return false;
            }

            const response = await fetch(url, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                ...(body ? { body: JSON.stringify(body) } : {}), // only include body if defined
            });

            const result = await response.json();
            if (!response.ok) throw new Error(result?.error || "Status update failed");

            toast.success(result.message || "Installation status updated");
            setInstallationOrder((prev: any) => ({ ...prev, status: nextStatus }));
            return true;
        } catch (err: any) {
            console.error("Status update error:", err.message);
            toast.error(err.message || "Something went wrong");
            return false;
        } finally {
            setLoading(false);
        }
    };

    // geting the defult selectedAgent and installetion Addreess and getting the brokarageForms
    useEffect(() => {
        if (installationOrder?.agent_id && agents.length > 0) {
            const matchedAgent = agents.find(agent => agent.id === installationOrder.agent_id);
            if (matchedAgent) {
                const option = {
                    value: matchedAgent.id,
                    label: `${matchedAgent.firstName} ${matchedAgent.lastName}`,
                    firstName: matchedAgent.firstName,
                    lastName: matchedAgent.lastName,
                    email: matchedAgent.email,
                    phone: matchedAgent.phone1,
                };
                setSelectedAgent(option);
                fetchLinkedProducts("agent", option.value);
            }
        }

        if (installationOrder?.installation_details?.installation_address) {
            setInstallationAddress(installationOrder.installation_details.installation_address);
        }

        if (installationOrder?.user_type) {
            fetchBrokerageFirms(installationOrder.user_type);
        }
    }, [installationOrder, agents]);

    // calling brokarage Teammembers based on selected Brokarage
    useEffect(() => {
        if (
            installationOrder?.brokerage_firm_id &&
            brokerageOptions.length > 0
        ) {
            const selectedFirm = brokerageOptions.find(
                (firm) => firm.value === installationOrder.brokerage_firm_id
            );

            if (
                selectedFirm &&
                selectedBrokerageFirm?.value !== selectedFirm.value
            ) {
                console.log("Selected Brokerage Firm:", selectedFirm);
                // setSelectedBrokerageFirm(selectedFirm);
                featchBrokerageTeammembers(selectedFirm);
            }
        }
    }, [installationOrder?.brokerage_firm_id, brokerageOptions.length]);

    useEffect(() => {
        const fetchPaymentMethods = async () => {
            const id = installationOrder?.inventory_source === "office" ? installationOrder?.team_member_id : installationOrder?.agent_id
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_API_URL}/payment-methods/by-supplier/${userId}/by-user/${id}`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                const data = await response.json();
                console.log("PaymentMethod :", data);
                setPaymentMethod(Array.isArray(data) ? data : []);
            } catch (err) {
                console.error("Error fetching payment methods:", err);
            } finally {
                setLoading(false);
            }
        };

        if (userId && installationOrder?.inventory_source) {
            fetchPaymentMethods();
        }
    }, [token, userId, installationOrder?.inventory_source]);

    // setting defult selectedProducts
    useEffect(() => {
        if (installationOrder?.line_items?.length > 0) {
            const mapped = installationOrder.line_items.map((item: any) => ({
                product_id: item.product_id,
                inventory_type: item.inventory_source || "",
                name: item.product_name || "",
                sku: item.sku || "",
                product_location_status: item.current_status || "",
                user_id: "", // You can enrich this if needed based on agent/office ID from elsewhere
                quantity: item.quantity,
                updateStatus: "",
                productionStatus: item.production_status || "",
                is_rotational: item.is_rotational,
                allocatedCount: item.rotational_allocated || 0,
            }));

            setSelectedProducts(mapped);
            console.log("Mapped Products:", mapped);
        }
    }, [installationOrder]);

    // setting defult allocatedUnits
    useEffect(() => {
        if (!installationOrder?.line_items?.length) return;

        const prefilledAllocations: {
            [linkedProductId: string]: {
                rotationalProductId: string;
                warehouseId: string;
                serial_id: string;
                serial_number: string;
                product_name: string;
                sku: string;
            }[];
        } = {};

        for (const item of installationOrder.line_items) {
            if (
                Array.isArray(item.serial_ids) &&
                item.serial_ids.length > 0 &&
                item.warehouse_id &&
                item.product_id
            ) {
                const key = item.is_rotational ? item.source_product_id : item.product_id;
                if (!key) continue;

                const allocations = item.serial_ids.map((sid: string, index: number) => ({
                    rotationalProductId: item.product_id,
                    warehouseId: item.warehouse_id,
                    serial_id: sid,
                    serial_number: item.serial_codes?.[index] || sid,
                    product_name: item.product_name || "Unknown Product",
                    sku: item.sku || "",
                }));

                prefilledAllocations[key] = allocations;
            }
        }

        setAllocatedUnits(prefilledAllocations);
    }, [installationOrder]);


    const [integrations, setIntegrations] = useState<PaymentGateway[]>([]);

    useEffect(() => {
        const fetchIntegrations = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/payments/gateway/created-by/${createSignage?.created_by?.id}`, {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                });
                if (!response.ok) {
                    throw new Error("Failed to fetch integrations.");
                }
                const data = await response.json();
                console.log('Methods ', data);
                setIntegrations(data);
            } catch (err) {
                // toast.error("Failed to load integrations.");
                setError(err instanceof Error ? err.message : "An unknown error occurred");
            } finally {
                setLoading(false);
            }
        };

        fetchIntegrations();
    }, [createSignage?.created_by?.id]);

    const [stripePromise, setStripePromise] = useState<Promise<Stripe | null> | null>(null);


    useEffect(() => {
        const stripeInfo = integrations?.find((method) => method.gateway === "stripe");
        console.log('Stripe info ', stripeInfo);
        if (stripeInfo && stripeInfo.publishable_key) {
            const promise = loadStripe(stripeInfo.publishable_key);
            setStripePromise(promise);
        }
    }, [integrations]);

    const completeOrder = async (getmethod: string) => {
        console.log("getmethod", getmethod);
        setLoading(true);

        try {
            if (["cheque", "bank_transfer"].includes(getmethod)) {
                // 🔁 Call Net30-style API
                const latestPayment = installationOrder?.payment_info?.[0]?.amount_due;
                console.log("latestPayment", latestPayment);
                const lastAmountDue = latestPayment ?? formik.values.total;
                console.log("lastAmountDue", lastAmountDue);
                const response = await fetch(
                    `${process.env.REACT_APP_API_URL}/installation_orders/${installationOrder?._id}/net30_payment`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`, // use token from context
                        },
                        body: JSON.stringify({
                            payment_id: formik.values.transactionId || "",
                            method: getmethod,
                            amount_paid: formik.values.partial_amount,
                            total_amount: lastAmountDue,
                            amount_due: Math.max(0, lastAmountDue - formik.values.partial_amount),
                            payment_date: new Date().toISOString(),
                        }),
                    }
                );

                if (!response.ok) {
                    throw new Error("Cheque/Bank payment failed.");
                }

            } else {
                // 🔁 Default online payment API
                const response = await fetch(
                    `${process.env.REACT_APP_API_URL}/installation_orders/${installationOrder?._id}/payment`,
                    {
                        method: "PUT",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                        },
                        body: JSON.stringify({
                            payment_id: "",
                            total_amount: formik.values.total,
                            amount_paid: 0,
                            amount_due: formik.values.total,
                            payment_date: new Date().toISOString(),
                            method: getmethod,
                        }),
                    }
                );

                if (!response.ok) {
                    throw new Error("Online payment failed.");
                }
            }

            toast.success("Payment submitted successfully!");
            navigate("/signage/jobs/installations");
            localStorage.removeItem("cart_id");

        } catch (error) {
            const errMessage =
                (error as Error).message || "An unknown error occurred";
            console.error("Order Failed:", errMessage);
            toast.error(`Error: ${errMessage}`);
        } finally {
            setLoading(false);
        }
    };

    const totalPaid = (installationOrder?.payment_info ?? []).reduce(
        (acc: number, payment: { amount_paid?: number | string }) =>
            acc + Number(payment.amount_paid || 0),
        0
    );


    const maxAllowed = (installationOrder?.payment_info ?? []).length > 0 ? Number((Number(installationOrder?.total_amount || 0) - totalPaid).toFixed(2)) : Number(installationOrder?.total_amount || 0);


    const remaingamount = ((installationOrder?.total_amount || 0) - totalPaid)

    const statusHistory: any[] = Array.isArray(installationOrder?.status_history)
        ? (installationOrder?.status_history as any[])
        : [];
    // console.log("statusHistory", statusHistory);
    const paymentInfo: PaymentInfoItem[] = [...(installationOrder?.payment_info || [])];

    const resolveOrderStatus = (status: number | undefined): string => {
        switch (status) {
            case null: return "";
            case 100: return "Draft";
            case 200: return "Finalized";
            case 300: return "Scheduled";
            case 400: return "In Progress";
            case 500: return "Completed";
            case 600: return "Canceled";
            default: return status !== undefined ? `Status ${status}` : "Unknown";
        }
    };


    const parseDate = (input: any): string => {
        try {
            return new Date(input).toLocaleString();
        } catch {
            return "Invalid Date";
        }
    };


    const isFieldEditable = (status: number, field: string): boolean => {
        const editableMap: Record<number, string[]> = {
            100: [
                // Created (Draft)
                "Priority",
                "Instructions",
                "Installer",
                "InstallationDate"
            ],
            200: [
                // Finalized
                "InstallationDate", // if ≥ 48h
                "Installer",
                "Instructions",
            ],
            300: [
                // Scheduled or Re-scheduled
                "InstallationDate", // if ≥ 48h
                "Installer",
                "Instructions",
            ],
            400: [
                // In Progress
                "Instructions",
            ],
            // 500 and 600: No edits allowed
        };

        const nonEditableStatuses = [500, 600]; // Completed, Cancelled

        if (nonEditableStatuses.includes(status)) return false;

        const editableFields = editableMap[status] || [];
        return editableFields.includes(field);
    };

    const fetchRotationalPoolProducts = async () => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/signage/${createSignage?.created_by?.id}/rotational-products`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            const data = await response.json();
            if (!response.ok) throw new Error(data.message || "Failed to fetch");
            console.log("Rotational Pool Products:", data);

            setRotationalPoolProducts(data); // ✅ store in state
        } catch (err: any) {
            console.error("Error fetching rotational products:", err.message);
            toast.error("Failed to fetch rotational pool products");
        }
    };

    const rotationalproductOptions = rotationalPoolProducts.map((p) => ({
        value: p._id,
        label: p.rotational_product?.name || "Unnamed Product",
        sku: p.rotational_product?.sku,
        fullProduct: p,
    }));


    const handleProductSelect = (selected: any) => {
        setSelectedProduct(selected);

        const warehouses = selected?.fullProduct?.warehouse_details || [];

        const options = warehouses.map((w: any) => ({
            value: w.warehouse._id,
            label: `${w.warehouse.label} (${w.available} available)`,
        }));

        setWarehouseOptions(options);
    };

    const fetchSerializedUnits = async (rotationalId: string, warehouseId: string) => {
        if (!userId || !token) return;

        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/signage/${createSignage?.created_by?.id}/warehouses/rotational-pool/${rotationalId}/warehouse/${warehouseId}/available-serialized-units`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            const data = await response.json();
            if (!response.ok) throw new Error(data.message || "Failed to fetch serialized pool");
            console.log("Serialized Units:", data);
            setAvailableSerializedUnits(data);
        } catch (err: any) {
            console.error("Fetch Serialized Units Error:", err.message);
            toast.error("Unable to fetch serialized units");
        }
    };

    useEffect(() => {
        if (installationOrder?.uploaded_files) {
            setUploadedFileMeta(installationOrder.uploaded_files);
        }
    }, [installationOrder]);

    // 📦 Allocate a single serial unit API call
    const allocateSerialUnit = async ({
        rotationalProductId,
        warehouseId,
        serialId,
    }: {
        rotationalProductId: string;
        warehouseId: string;
        serialId: string;
    }) => {
        try {
            const res = await fetch(
                `${process.env.REACT_APP_API_URL}/signage/${createSignage?.created_by?.id}/rotational-products/${rotationalProductId}/allocate-serialized-unit`,
                {
                    method: "POST",
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        warehouse_id: warehouseId,
                        serial_id: serialId,
                        order_id: installationOrder?._id,
                        order_number: installationOrder?.order_number || "",
                    }),
                }
            );

            if (!res.ok) {
                const error = await res.json();
                throw new Error(error.message || "Failed to allocate unit");
            }

            return true;
        } catch (err) {
            console.error("Allocation API error:", err);
            toast.error("Allocation failed");
            return false;
        }
    };



    if (!isLoaded) return <div>Loading...</div>;

    return (
        <div className="content">
            <div className="card">
                <div className="card-body">
                    <h2 className="text-center">Installation Order Details</h2>
                    <div className="row mb-3">
                        <div className="col-md-12 d-flex justify-content-between">
                            <div>
                                <h4>Order Status : {
                                    installationOrder?.status === 100
                                        ? "Draft"
                                        : installationOrder?.status === 200
                                            ? "Finalized"
                                            : installationOrder?.status === 300
                                                ? "Scheduled"
                                                : installationOrder?.status === 400
                                                    ? "In Progress"
                                                    : installationOrder?.status === 500
                                                        ? "Completed"
                                                        : installationOrder?.status === 600
                                                            ? "Canceled"
                                                            : "Unknown"
                                }</h4>
                            </div>
                            <div>
                                {installationOrder?.status === 100 && (
                                    <button className="btn btn-primary" onClick={() => handleInstallationStatus(200)}>
                                        Click to Finalize
                                    </button>
                                )}

                                {/* {installationOrder?.status === 200 && (
                                <button className="btn btn-primary" onClick={() => handleInstallationStatus(300)}>
                                    Click to Schedule
                                </button>
                            )}

                            {installationOrder?.status === 300 && (
                                <button className="btn btn-primary" onClick={() => handleInstallationStatus(300)}>
                                    Click to Re-Schedule
                                </button>
                            )} */}
                                {installationOrder?.status === 300 && (
                                    <button className="btn btn-primary ms-3" onClick={() => handleInstallationStatus(400)}>
                                        Click to In Progress
                                    </button>
                                )}

                                {installationOrder?.status === 400 && (
                                    <button className="btn btn-primary" onClick={() => handleInstallationStatus(500)}>
                                        Click to Complete
                                    </button>
                                )}

                                {(installationOrder?.status <= 300) && (
                                    <button className="btn btn-danger ms-3" onClick={() => handleInstallationStatus(600)}>
                                        Cancel Order
                                    </button>
                                )}
                                {
                                    installationOrder?.status <= 300 && (
                                        <Link
                                            to={`/signageteammember/editInstallation/${installationId}`}
                                            className="btn btn-info ms-3"
                                        >
                                            Edit
                                        </Link>
                                    )
                                }
                            </div>

                        </div>

                    </div>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="row mt-5">
                            <div className="col-md-4 mb-3">
                                <label className="form-label">
                                    Order ID
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={installationOrder?.order_number || ""}
                                    disabled
                                />
                            </div>

                            <div className="col-md-4 mb-3">
                                <label htmlFor="userType" className="form-label">
                                    Buyer Type
                                </label>
                                <Select
                                    className="form-control"
                                    id="userType"
                                    name="userType"
                                    options={buyerOptions}
                                    value={buyerOptions?.find(
                                        (option) =>
                                            option.value === formik.values.userType
                                    )}
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("userType", selectedOption?.value)
                                        fetchBrokerageFirms(selectedOption?.value || "")
                                    }
                                    }
                                    onBlur={formik.handleBlur}
                                    isDisabled
                                />
                            </div>
                            {formik.values.userType === "brokerageFirm" ? (
                                <>
                                    <div className="col-md-4 mb-3">
                                        <label htmlFor="brokerageFirmsId">
                                            Select Brokerage Firm
                                        </label>
                                        <Select
                                            className="form-control"
                                            id="brokerageFirmsId"
                                            name="brokerageFirmsId"
                                            options={brokerageOptions}
                                            value={brokerageOptions?.find((option) => option.value === formik.values.brokerageFirmsId) || null}
                                            onChange={(selected) => {
                                                // setBuyerType(selected?.value || "");
                                                featchBrokerageTeammembers(selected || null)
                                                formik.setFieldValue("brokerageFirmsId", selected?.value || "");
                                            }
                                            }
                                            onBlur={formik.handleBlur}
                                            isDisabled
                                        />
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <label htmlFor="officeSelection">
                                            Select Team Member
                                        </label>
                                        <Select
                                            id="teamMemberId"
                                            name="teamMemberId"
                                            className="form-control"
                                            options={teamMemberOptions}
                                            value={teamMemberOptions?.find((option) => option.value === formik.values.teamMemberId) || null}
                                            onChange={(selected) => {
                                                formik.setFieldValue("teamMemberId", selected?.value || "");
                                                setSelectedTeamMember(selected);
                                            }}
                                            onBlur={formik.handleBlur}
                                            isDisabled
                                            placeholder="Select a team member"
                                        />
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <label htmlFor="officeSelection">
                                            Select Office
                                        </label>
                                        <Select
                                            className="form-control"
                                            id="officeSelection"
                                            options={officeOptions}
                                            value={
                                                officeOptions?.find(
                                                    (option) =>
                                                        option.value === formik.values.office._id
                                                ) || null
                                            }
                                            onChange={(selected) => {
                                                fetchOfficeAgents(selected);
                                                console.log("Selected Office:", selected);
                                                formik.setFieldValue(
                                                    "userFirstName",
                                                    selected?.firstName || ""
                                                );
                                                formik.setFieldValue(
                                                    "userLastName",
                                                    selected?.lastName || ""
                                                );
                                                formik.setFieldValue(
                                                    "userEmail",
                                                    selected?.email || ""
                                                );
                                                formik.setFieldValue(
                                                    "userPhone",
                                                    selected?.phone || ""
                                                );
                                            }}
                                            isDisabled
                                        />
                                    </div>
                                    {officeAgentOptions && (
                                        <div className="col-md-4 mb-3">
                                            <label htmlFor="officeSelection">
                                                Select Agent
                                            </label>
                                            <Select
                                                className="form-control"
                                                id="officeAgentSelection"
                                                options={officeAgentOptions}
                                                value={officeAgentOptions?.find((option) => option.value === formik.values.agent) || null}
                                                onChange={(selected) => {
                                                    setSelectedOfficeAgent(selected);
                                                    setSelectedAgent(selected);
                                                    formik.setFieldValue(
                                                        "userFirstName",
                                                        selected?.firstName || ""
                                                    );
                                                    formik.setFieldValue(
                                                        "userLastName",
                                                        selected?.lastName || ""
                                                    );
                                                    formik.setFieldValue(
                                                        "userEmail",
                                                        selected?.email || ""
                                                    );
                                                    formik.setFieldValue(
                                                        "userPhone",
                                                        selected?.phone || ""
                                                    );
                                                }}
                                                isDisabled
                                            />
                                        </div>
                                    )}
                                </>
                            ) : (
                                formik.values.userType === "agent" && (
                                    <div className="col-md-4 mb-3">
                                        <label htmlFor="agentSelection">
                                            Select Agent
                                        </label>
                                        <Select
                                            className="form-control"
                                            id="agentSelection"
                                            options={agentOptions}
                                            value={agentOptions?.find((option) => option.value === formik.values.agent) || null}
                                            onChange={(selected) => {
                                                setSelectedAgent(selected);
                                                formik.setFieldValue("agent", selected?.value || "")
                                                formik.setFieldValue(
                                                    "userFirstName",
                                                    selected?.firstName || ""
                                                );
                                                formik.setFieldValue(
                                                    "userLastName",
                                                    selected?.lastName || ""
                                                );
                                                formik.setFieldValue(
                                                    "userEmail",
                                                    selected?.email || ""
                                                );
                                                formik.setFieldValue(
                                                    "userPhone",
                                                    selected?.phone || ""
                                                );
                                            }}
                                            onBlur={formik.handleBlur}
                                            isDisabled
                                        />
                                    </div>
                                )
                            )}

                            <div className="col-md-4 mb-3">
                                <label className="form-label">
                                    Email
                                </label><input type="text" value={formik.values.userEmail} className="form-control" disabled />
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label">
                                    Phone Number
                                </label><input type="text" value={formik.values.userPhone} className="form-control" disabled />
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label">
                                    Billing Address
                                </label><input type="text" value={`${formik.values.billing_address?.addressLine1}, ${formik.values.billing_address?.city}, ${formik.values.billing_address?.state}`} className="form-control" disabled />
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label">
                                    Installation Address
                                </label><input type="text" value={`${formik.values.installation_address?.addressLine1}, ${formik.values.installation_address?.city}, ${formik.values.installation_address?.state}`} className="form-control" disabled />
                            </div>

                        </div>

                        <div className="row mb-3">
                            <div className="col-md-4 mb-3">
                                <label className="form-label">
                                    Scheduled Date
                                </label>
                                <input
                                    type="date"
                                    className="form-control"
                                    id="scheduled_date"
                                    name="scheduled_date"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.scheduled_date}
                                    readOnly={!isFieldEditable(installationOrder?.status ?? 0, "InstallationDate")}
                                />
                                {/* {formik.touched.scheduled_date &&
                      formik.errors.scheduled_date && (
                        <div className="invalid-feedback">
                          {formik.errors.scheduled_date}
                        </div>
                      )} */}
                            </div>
                            <div className="col-md-2 mb-3">
                                <label className="form-label">
                                    Jobs Today
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="jobs_today"
                                    name="jobs_today"
                                    value={scheduledJobsCount || ""}
                                    disabled
                                />
                                {formik.touched.jobs_today &&
                                    formik.errors.jobs_today && (
                                        <div className="invalid-feedback">
                                            {formik.errors.jobs_today}
                                        </div>
                                    )}
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label">
                                    Assigned To
                                </label>
                                <Select
                                    id="installeId"
                                    name="installeId"
                                    options={installer}
                                    value={installer?.find((option) => option.value === formik.values.installeId) || null}
                                    onChange={(selected) => {
                                        setSelectedInstaller(selected);
                                        formik.setFieldValue("installeId", selected?.value || "")
                                    }
                                    }
                                    onBlur={formik.handleBlur}
                                    isDisabled={!isFieldEditable(installationOrder?.status ?? 0, "Installer")}
                                />
                                {/* {formik.touched.installeId && formik.errors.installeId && (
                      <div className="text-danger">{formik.errors.installeId}</div>
                    )} */}
                            </div>
                            <div className="col-md-2 mb-3">
                                <label className="form-label">
                                    Priority
                                </label>
                                <Select
                                    id="priority"
                                    name="priority"
                                    options={priorityOptions}
                                    value={priorityOptions.find((option) => option.value === formik.values.priority) || null}
                                    onChange={(option) =>
                                        formik.setFieldValue("priority", option?.value || "")
                                    }
                                    onBlur={formik.handleBlur}
                                    isDisabled={!isFieldEditable(installationOrder?.status ?? 0, "Priority")}
                                />

                                {/* {formik.touched.priority && formik.errors.priority && (
                      <div className="text-danger">{formik.errors.priority}</div>
                    )} */}
                            </div>
                        </div>

                        <div className="row mb-3">
                            <h3 className="text-center">Map View</h3>
                            {/* <div style={{border:"solid 1px #cccccc", width:"100%", height:"200px"}}></div> */}
                            <div style={mapContainerStyle}>
                                <GoogleMap
                                    mapContainerStyle={mapContainerStyle}
                                    zoom={10}
                                    center={selectedLocation || center}
                                    // onClick={handleMapClick}
                                    onLoad={(map) => {
                                        mapRef.current = map;
                                    }}
                                >
                                    {/* 🔵 Draggable marker from selected location */}
                                    {/* {selectedLocation && (
                                        <Marker
                                            position={selectedLocation}
                                            // draggable={true}
                                            onDragEnd={handleMarkerDragEnd}
                                        />
                                    )} */}

                                    {/* 🟢 All fetched installation markers */}
                                    {installationLocations.map((loc, idx) => {
                                        const a = loc.address;
                                        const lat = a.latitude;
                                        const lng = a.longitude;
                                        if (!lat || !lng || isNaN(lat) || isNaN(lng)) return null;

                                        let status = "unknown";
                                        let markerColor = "http://maps.google.com/mapfiles/ms/icons/red-dot.png";
                                        switch (loc.status) {
                                            case 100:
                                                status = "draft";
                                                markerColor = "http://maps.google.com/mapfiles/ms/icons/orange-dot.png";
                                                break;
                                            case 200:
                                                status = "finalized";
                                                markerColor = "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png";
                                                break;
                                            case 300:
                                                status = "scheduled";
                                                markerColor = "http://maps.google.com/mapfiles/ms/icons/green-dot.png";
                                                break;
                                            case 400:
                                                status = "in_progress";
                                                markerColor = "http://maps.google.com/mapfiles/ms/icons/blue-dot.png";
                                                break;
                                            case 500:
                                                status = "completed";
                                                markerColor = "http://maps.google.com/mapfiles/ms/icons/purple-dot.png";
                                                break;
                                            case 600:
                                                status = "canceled";
                                                markerColor = "http://maps.google.com/mapfiles/ms/icons/red-dot.png";
                                                break;
                                        }

                                        return (
                                            <Marker
                                                key={idx}
                                                position={{ lat, lng }}
                                                icon={{ url: markerColor }}
                                                onClick={async () => {
                                                    try {
                                                        const details = await getInstallationLocationById(loc._id);
                                                        if (!details) return;

                                                        // 🧠 Resolve status label from code
                                                        let statusLabel = "Unknown";
                                                        switch (details.status) {
                                                            case 100: statusLabel = "Draft"; break;
                                                            case 200: statusLabel = "Finalized"; break;
                                                            case 300: statusLabel = "Scheduled"; break;
                                                            case 400: statusLabel = "In Progress"; break;
                                                            case 500: statusLabel = "Completed"; break;
                                                            case 600: statusLabel = "Canceled"; break;
                                                        }

                                                        // 🧠 Resolve member (agent or office)
                                                        const memberName = details.agent_name || details.office?.officeName || "N/A";

                                                        const popupContent = `
          <div>
            <b>📦 Product:</b> ${details.product_name || "N/A"}<br/>
            <b>📅 Date:</b> ${details.scheduled_date
                                                                ? new Date(details.scheduled_date).toDateString()
                                                                : "N/A"
                                                            }<br/>
            <b>⚙️ Status:</b> ${statusLabel}<br/>
            <b>👤 Member:</b> ${memberName}
          </div>
        `;

                                                        const infoWindow = new google.maps.InfoWindow({
                                                            content: popupContent,
                                                        });

                                                        infoWindow.setPosition({ lat, lng });
                                                        infoWindow.open(mapRef.current);
                                                    } catch (err) {
                                                        toast.error("Failed to fetch details for this marker.");
                                                        console.error("Marker API call failed", err);
                                                    }
                                                }}

                                            />
                                        );
                                    })}
                                </GoogleMap>
                            </div>

                        </div>

                        <h4 className="text-center">Products in Order</h4>
                        <div className="row mb-5">
                            <div className="col-md-12">
                                <table>
                                    <thead>
                                        <tr>
                                            {/* <th className="text-center">SKU</th> */}
                                            <th className="text-center">Product Name</th>
                                            <th className="text-center">SKU</th>
                                            <th className="text-center">Quantity </th>
                                            <th className="text-center">Rotational</th>
                                            <th className="text-center">Product Location Current Status</th>
                                            <th className="text-center">Production Status </th>
                                            <th className="text-center">Action</th>
                                            {/* <th className="text-center">Discount</th>
                          <th className="text-center">Price</th>
                          <th className="text-center">Tax Name</th>
                          <th className="text-center">Tax Rate </th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedProducts?.filter((p) => p.inventory_type !== "rotational" && p.inventory_type !== "")?.map((item, index) => {
                                            const allocated = allocatedUnits[item.product_id] || [];
                                            const remaining = item.quantity - allocated.length;
                                            return (
                                                <tr key={item.product_id}>
                                                    <td className="text-center">{item.name}</td>
                                                    <td className="text-center">{item.sku}</td>
                                                    <td className="text-center">{item.quantity}</td>
                                                    <td className="text-center">{item.is_rotational ? "Yes" : "No"}</td>
                                                    <td className="text-center">
                                                        <div className="d-flex justify-content-evenly">
                                                            <span className="bg-warning px-3 py-2" style={{ borderRadius: "10px" }}>
                                                                {item.product_location_status?.replace(/_/g, " ") || "N/A"}
                                                            </span>
                                                            {(installationOrder.status === 400 || installationOrder.status === 500) ?
                                                                <></>
                                                                :
                                                                <Link
                                                                    className="btn btn-small btn-primary"
                                                                    to={
                                                                        item.inventory_type === "agent"
                                                                            ? "/signageteammember/incomingAgentProducts"
                                                                            : "/signageteammember/incomingOfficeProducts"
                                                                    }
                                                                >
                                                                    Update Status
                                                                </Link>
                                                            }
                                                        </div>
                                                        {/* {openStatusIndex === index && (
                                <>
                                  <div className="mt-2">
                                    <Select
                                      id={`update_status_${index}`}
                                      name={`update_status_${index}`}
                                      options={[
                                        { value: "with supplier", label: "With Supplier" },
                                        { value: "in transit", label: "In Transit" },
                                        { value: "on site", label: "On Site" },
                                        { value: "declined", label: "Declined" },
                                      ]}
                                      onChange={(option) => {
                                        const updated = [...installationOrder.line_items];
                                        updated[index].current_status = option?.value || "";
                                        setInstallationOrder({ ...installationOrder, line_items: updated });
                                      }}
                                    />
                                  </div>
                                  <div className="mt-2">
                                    <button
                                      className="btn btn-info btn-sm w-100"
                                      onClick={() => setOpenStatusIndex(null)}
                                    >
                                      Update
                                    </button>
                                  </div>
                                </>
                              )} */}
                                                    </td>
                                                    <td className="text-center">
                                                        <div className="d-flex justify-content-evenly">
                                                            <span className="bg-secondary px-3 py-2 text-white" style={{ borderRadius: "10px" }}>
                                                                {item.productionStatus?.replace(/_/g, " ") || "Not Started"}
                                                            </span>
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-primary"
                                                                onClick={() =>
                                                                    setOpenProductStatusIndex(openProductStatusIndex === index ? null : index)
                                                                }
                                                                disabled={installationOrder.status === 400 || installationOrder.status === 500}
                                                            >
                                                                Update Status
                                                            </button>
                                                        </div>
                                                        {openProductStatusIndex === index && (
                                                            <>
                                                                <div className="mt-2">
                                                                    <Select
                                                                        id={`product_status_${index}`}
                                                                        name={`product_status_${index}`}
                                                                        options={[
                                                                            { value: "not_started", label: "Not Started" },
                                                                            { value: "in_queue", label: "In Queue" },
                                                                            { value: "in_production", label: "In Production" },
                                                                            { value: "quality_check", label: "Quality Check" },
                                                                            { value: "ready_for_pickup", label: "Ready For Pickup" },
                                                                            { value: "ready_for_installation", label: "Ready for Installation" },
                                                                        ]}
                                                                        value={{ value: item.productionStatus, label: item.productionStatus }}
                                                                        onChange={(option) => {
                                                                            const updated = [...selectedProducts];
                                                                            updated[index].productionStatus = option?.value || "";
                                                                            setSelectedProducts(updated);
                                                                        }}
                                                                    />
                                                                </div>
                                                                <div className="mt-2">
                                                                    <button
                                                                        className="btn btn-info btn-sm w-100"
                                                                        onClick={() => {
                                                                            const selectedStatus = selectedProducts[index].productionStatus;
                                                                            const productId = selectedProducts[index].product_id;
                                                                            updateProductionStatus(productId, selectedStatus);
                                                                            setOpenProductStatusIndex(null);
                                                                        }}
                                                                        disabled={installationOrder.status === 400 || installationOrder.status === 500}
                                                                    >
                                                                        Update
                                                                    </button>
                                                                </div>
                                                            </>
                                                        )}
                                                    </td>
                                                    <td className="text-center">
                                                        {/* {
                                  remaining > 0 ? <button
                                    type="button"
                                    className="btn btn-success"
                                    onClick={() => {
                                      setLinkedProductIdContext(item.product_id);
                                      setSelectedProduct(null);                // Clear previous product
                                      setSelectedWarehouse(null);             // Clear previous warehouse
                                      setAvailableSerializedUnits([]);        // Clear previous serialized units
                                      fetchRotationalPoolProducts();          // Fetch fresh rotational products
                                      setShowAllocateModal(true);
                                    }}
                                  >
                                    Allocate
                                  </button> :
                                    <button
                                      type="button"
                                      className="btn btn-success"
                                      onClick={() => {
                                        setShowViewInventoryModal(true);
                                      }}
                                    >
                                      View Inventory
                                    </button>
                                } */}
                                                        {(installationOrder?.status === 200 || installationOrder?.status === 300) &&
                                                            <button
                                                                type="button"
                                                                className="btn btn-success"
                                                                disabled={remaining <= 0}
                                                                onClick={() => {
                                                                    setLinkedProductIdContext(item.product_id);
                                                                    setSelectedProduct(null);                // Clear previous product
                                                                    setSelectedWarehouse(null);             // Clear previous warehouse
                                                                    setAvailableSerializedUnits([]);        // Clear previous serialized units
                                                                    fetchRotationalPoolProducts();          // Fetch fresh rotational products
                                                                    setShowAllocateModal(true);
                                                                }}
                                                            >
                                                                Allocate
                                                            </button>
                                                        }

                                                    </td>
                                                </tr>
                                            )
                                        })
                                        }
                                    </tbody>

                                </table>
                            </div>

                        </div>

                        <div className="row mb-3">
                            <div className="col-md-6">
                                <h3>Instructions </h3>
                                <textarea
                                    name="instructions"
                                    id="instructions"
                                    className="form-control"
                                    value={formik.values.instructions}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    rows={4}
                                    readOnly={!isFieldEditable(installationOrder?.status ?? 0, "Instructions")}
                                ></textarea>

                                {installationOrder?.status === 400 &&
                                    <div className="col-md-12 mt-5">
                                        <label htmlFor="">Proof of Installation</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            id="image"
                                            name="image"
                                            multiple
                                            onChange={(e) => {
                                                const files = Array.from(e.target.files || []);
                                                const newPreviews = files.map((file) => ({
                                                    file,
                                                    url: URL.createObjectURL(file),
                                                }));
                                                setPreviewFiles((prev) => [...prev, ...newPreviews]);
                                            }}
                                        />

                                        <button
                                            type="button"
                                            className="btn btn-success mt-3"
                                            onClick={async () => {
                                                try {
                                                    const uploads = await Promise.all(
                                                        previewFiles.map(async ({ file }) => {
                                                            const path = await uploadFile(file); // ✅ Reuse function
                                                            return {
                                                                file_name: file.name,
                                                                file_url: path,
                                                                content_type: file.type,
                                                                uploaded_date: new Date().toISOString(),
                                                            };
                                                        })
                                                    );

                                                    const allFiles = [...uploadedFileMeta, ...uploads];
                                                    const uniqueByName = allFiles.filter(
                                                        (file, index, self) =>
                                                            index === self.findIndex((f) => f.file_name === file.file_name)
                                                    );

                                                    setUploadedFileMeta(uniqueByName);
                                                    setPreviewFiles([]); // clear previews after upload
                                                    toast.success("Files uploaded successfully!");
                                                } catch (err) {
                                                    console.error("Upload error:", err);
                                                    toast.error("Failed to upload files.");
                                                }
                                            }}
                                        >
                                            Upload
                                        </button>


                                        <div className="row mt-3">
                                            {uploadedFileMeta?.map((file, index) => (
                                                <div key={index} className="col-md-3 position-relative mb-3">
                                                    <div
                                                        className="position-absolute top-0 end-0 bg-danger text-white rounded-circle"
                                                        style={{
                                                            width: "20px",
                                                            height: "20px",
                                                            textAlign: "center",
                                                            cursor: "pointer",
                                                            zIndex: 2,
                                                        }}
                                                        onClick={() => {
                                                            setUploadedFileMeta((prev) => prev.filter((_, i) => i !== index));
                                                        }}
                                                    >
                                                        &times;
                                                    </div>
                                                    <div className="border p-2">
                                                        <img
                                                            src={`${process.env.REACT_APP_API_URL}/${file.file_url.replace(/\\/g, "/")}`}
                                                            alt={file.file_name}
                                                            className="img-fluid"
                                                            style={{ height: "150px", objectFit: "cover", width: "100%" }}
                                                        />
                                                        <div className="small text-center mt-1 text-muted">{file.file_name}</div>
                                                    </div>
                                                </div>
                                            ))}

                                            {previewFiles?.map((item, index) => (
                                                <div key={`preview-${index}`} className="col-md-3 position-relative mb-3">
                                                    <div
                                                        className="position-absolute top-0 end-0 bg-danger text-white rounded-circle"
                                                        style={{
                                                            width: "20px",
                                                            height: "20px",
                                                            textAlign: "center",
                                                            cursor: "pointer",
                                                            zIndex: 2,
                                                        }}
                                                        onClick={() => {
                                                            URL.revokeObjectURL(item.url);
                                                            setPreviewFiles(previewFiles.filter((_, i) => i !== index));
                                                        }}
                                                    >
                                                        &times;
                                                    </div>
                                                    <div className="border p-2">
                                                        <img
                                                            src={item.url}
                                                            alt={`preview-${index}`}
                                                            className="img-fluid"
                                                            style={{ height: "150px", objectFit: "cover", width: "100%" }}
                                                        />
                                                        <div className="small text-center mt-1 text-muted">{item.file.name}</div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                }

                            </div>
                            <div className="col-md-4 offset-md-2">
                                <h3>Fees</h3>
                                <table className="calculation-table">
                                    <tbody>
                                        {/* <tr>
                          <th>Item Value:</th>
                          <td>$100.00</td>
                        </tr> */}
                                        <tr>
                                            <th>Discount:</th>
                                            <th>${Number(formik.values.discount).toFixed(2)}</th>
                                        </tr>
                                        <tr>
                                            <th>Installation Fee:</th>
                                            <th>${Number(formik.values.installation_charge).toFixed(2)}</th>
                                        </tr>
                                        <tr>
                                            <th>Tax:</th>
                                            <th>${Number(formik.values.tax).toFixed(2)}</th>
                                        </tr>
                                        <tr>
                                            <th>Subtotal:</th>
                                            <th>${Number(formik.values.subtotal).toFixed(2)}</th>
                                        </tr>
                                        <tr>
                                            <th>Total:</th>
                                            <th>${Number(formik.values.total).toFixed(2)}</th>
                                        </tr>

                                        {(installationOrder?.payment_info ?? []).length > 0 && (
                                            <>
                                                <tr>
                                                    <th>Already Paid:</th>
                                                    <th className="text-end">${totalPaid.toFixed(2)}</th>
                                                </tr>
                                                <tr>
                                                    <th>Remaining Balance:</th>
                                                    <th className="text-end">
                                                        <strong>${remaingamount.toFixed(2)}</strong>
                                                    </th>
                                                </tr>
                                            </>
                                        )}

                                        {formik.values.enable_partial_payment && (
                                            <tr>
                                                <th>Partial Payment:</th>
                                                <th className="text-end">
                                                    <strong>${Number(formik.values.partial_amount || 0).toFixed(2)}</strong>
                                                </th>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>

                            </div>
                        </div>

                        <button
                            type="submit"
                            className="btn btn-info mt-4 float-end"
                            disabled={formSubmitting || installationOrder?.status >= 400}
                        >
                            Submit
                        </button>
                    </form>
                    <div className="row mt-3">
                        <div className="col-md-9">
                            {((installationOrder?.status ?? 0) > 100) && installationOrder?.payment_status !== "Paid" && (
                                <>
                                    <h3>Payment Methods</h3>
                                    <button
                                        type="button"
                                        className="btn btn-success material-shadow-none btn-sm mt-2 mt-sm-0 me-1"
                                        onClick={() => setPayment((prev) => !prev)}
                                    >
                                        <i className="mdi mdi-cash-multiple align-middle me-1"></i>
                                        Process Payment
                                    </button>
                                </>
                            )}
                            {payment && installationOrder?._id && (
                                <div className="card-body">
                                    <div className="row my-3">
                                        <div className="col-md-6">
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="enable_partial_payment"
                                                    name="enable_partial_payment"
                                                    onChange={(e) => {
                                                        formik.handleChange(e);
                                                        if (!e.target.checked) {
                                                            formik.setFieldValue("partial_amount", 0);
                                                        }
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                    checked={formik.values.enable_partial_payment}
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="enable_partial_payment"
                                                >
                                                    Enable Partial Payment
                                                </label>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            {formik.values.enable_partial_payment && (
                                                <>
                                                    <div className="mt-2">
                                                        <label className="form-label">
                                                            Amount to Collect Now :
                                                        </label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="partial_amount"
                                                            id="partial_amount"
                                                            onChange={(e) => {
                                                                const enteredValue = Number(e.target.value);
                                                                formik.setFieldValue(
                                                                    "partial_amount",
                                                                    enteredValue <= maxAllowed ? enteredValue : maxAllowed
                                                                );
                                                            }}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.partial_amount === 0 ? "" : formik.values.partial_amount}
                                                            placeholder="0"
                                                            min={0}
                                                        />

                                                    </div>
                                                    <div className="mt-2">
                                                        <span>
                                                            Remaining Balance: $
                                                            {(Number(remaingamount) - Number(formik.values.partial_amount || 0)).toFixed(2)}

                                                        </span>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-12">
                                            <Elements stripe={stripePromise}>
                                                <div>
                                                    <h5 className="mb-1">Payment Selection</h5>
                                                    <p className="text-muted mb-2">
                                                        Please select payment method
                                                    </p>
                                                </div>

                                                {/* Payment Methods */}
                                                <div className="row">
                                                    <div className="col-lg-3 mb-3 col-sm-6">
                                                        <div className="form-check card-radio">
                                                            <input
                                                                id="paymentMethodOnline"
                                                                name="paymentMethod"
                                                                type="radio"
                                                                className="form-check-input"
                                                                checked={selectedPaymentMethod === "online"}
                                                                onChange={() =>
                                                                    setSelectedPaymentMethod("online")
                                                                }
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="paymentMethodOnline"
                                                            >
                                                                <i className="ri-bank-card-fill align-bottom"></i>
                                                                <span> Online Payment</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3 mb-3 col-sm-6">
                                                        <div className="form-check card-radio">
                                                            <input
                                                                id="paymentMethodcheque"
                                                                name="paymentMethod"
                                                                type="radio"
                                                                className="form-check-input"
                                                                checked={selectedPaymentMethod === "cheque"}
                                                                onChange={() =>
                                                                    setSelectedPaymentMethod("cheque")
                                                                }
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="paymentMethodcheque"
                                                            >
                                                                <i className="ri-bank-card-fill align-bottom"></i>
                                                                <span> Cheque</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3 mb-3 col-sm-6">
                                                        <div className="form-check card-radio">
                                                            <input
                                                                id="paymentMethodbank_transfer"
                                                                name="paymentMethod"
                                                                type="radio"
                                                                className="form-check-input"
                                                                checked={selectedPaymentMethod === "bank_transfer"}
                                                                onChange={() =>
                                                                    setSelectedPaymentMethod("bank_transfer")
                                                                }
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="paymentMethodbank_transfer"
                                                            >
                                                                <i className="ri-bank-card-fill align-bottom"></i>
                                                                <span> Bank Transfer</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    {(formik.values.enable_partial_payment || installationOrder?.payment_info?.length) ? <></> :
                                                        (
                                                            paymentMethod?.map((method) => (
                                                                <div className="col-lg-3 mb-3 col-sm-6" key={method._id}>
                                                                    <div className="form-check card-radio">
                                                                        <input
                                                                            id={`paymentMethod_${method._id}`}
                                                                            name="paymentMethod"
                                                                            type="radio"
                                                                            className="form-check-input"
                                                                            checked={
                                                                                selectedPaymentMethod === method.name
                                                                            }
                                                                            onChange={() =>
                                                                                setSelectedPaymentMethod(method.name)
                                                                            }
                                                                        />
                                                                        <label
                                                                            className="form-check-label"
                                                                            htmlFor={`paymentMethod_${method._id}`}
                                                                        >
                                                                            <i className="ri-bank-card-fill align-bottom"></i>
                                                                            <span> {method.name}</span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            ))
                                                        )
                                                    }
                                                </div>

                                                {selectedPaymentMethod === "online" ? (
                                                    <div className="collapse show mt-4">
                                                        <div className="card p-4 border shadow-none">
                                                            <PaymentFormManualOrder
                                                                url="installation_orders"
                                                                method="POST"
                                                                supplierId={installationOrder?.signage_id}
                                                                totalAmount={remaingamount ? remaingamount : installationOrder?.total_amount}
                                                                paidAmount={
                                                                    formik.values.partial_amount === 0
                                                                        ? (Number(installationOrder?.total_amount || 0) - totalPaid)
                                                                        : formik.values.partial_amount
                                                                }
                                                                orderId={installationOrder?._id}
                                                                selectedPaymentMethod={selectedPaymentMethod}
                                                                onPaymentSuccess={(paymentIntentId) => {
                                                                    console.log(
                                                                        "Payment Success: ",
                                                                        paymentIntentId
                                                                    );
                                                                    // formik.handleSubmit(); // Proceed to order completion
                                                                }}
                                                                userId={installationOrder?.inventory_source === "office" ? installationOrder?.team_member_id : installationOrder?.agent_id}
                                                                userEmail={installationOrder?.user_email}
                                                            />
                                                        </div>
                                                    </div>
                                                ) : (
                                                    ["cheque", "bank_transfer"].includes(selectedPaymentMethod) ? (
                                                        <div className="mt-4">
                                                            <div className="card p-3 border shadow-none">
                                                                <h4 className="mb-3">
                                                                    {selectedPaymentMethod === "cheque" ? "Cheque Payment Details" : "Bank Transfer Details"}
                                                                </h4>
                                                                <div className="row">
                                                                    <div className="mb-3 col-md-6">
                                                                        <label htmlFor="transactionId" className="form-label">
                                                                            Transaction ID
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="transactionId"
                                                                            value={formik.values.transactionId} // Adjust as needed or manage with new state
                                                                            onChange={(e) => formik.setFieldValue("transactionId", e.target.value)}
                                                                        />
                                                                    </div>

                                                                    <div className="mb-3 col-md-6">
                                                                        <label htmlFor="amount" className="form-label">
                                                                            Amount
                                                                        </label>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            id="amount"
                                                                            value={formik.values.partial_amount === 0
                                                                                ? (Number(installationOrder?.total_amount || 0) - totalPaid)
                                                                                : formik.values.partial_amount}
                                                                            // onChange={(e) =>
                                                                            //     formik.setFieldValue(
                                                                            //         "partial_amount",
                                                                            //         Number(e.target.value) <= maxAllowed ? Number(e.target.value) : maxAllowed
                                                                            //     )
                                                                            // }
                                                                            disabled
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary"
                                                                    onClick={() => {
                                                                        completeOrder(selectedPaymentMethod);
                                                                    }}
                                                                >
                                                                    Submit Payment
                                                                </button>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        selectedPaymentMethod ? (
                                                            <div className="d-flex align-items-start gap-3 mt-4">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary"
                                                                    onClick={() => {
                                                                        completeOrder(selectedPaymentMethod);
                                                                    }}
                                                                >
                                                                    Complete Order
                                                                </button>
                                                            </div>
                                                        ) : null
                                                    )
                                                )}
                                            </Elements>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="card mt-4">
                        <div className="card-header">
                            <h5 className="card-title mb-0">Installation Log</h5>
                        </div>
                        <div className="card-body">
                            <ul className="list-unstyled vstack gap-3">
                                {
                                    <strong>Order Created on {parseDate(installationOrder?.created_at)}</strong>
                                }
                                {/* ✅ Payment Logs */}
                                {paymentInfo.slice().reverse().map((payment, idx) => {
                                    const status =
                                        payment.amount_due === 0
                                            ? "Paid"
                                            : payment.amount_paid > 0
                                                ? "Partial Payment"
                                                : "Pending";

                                    const badgeClass =
                                        status === "Paid"
                                            ? "bg-success-subtle text-success"
                                            : status === "Partial Payment"
                                                ? "bg-warning-subtle text-warning"
                                                : "bg-danger-subtle text-danger";

                                    return (
                                        <li key={`payment-${idx}`}>
                                            <div>
                                                <strong>💰 Payment:</strong>{" "}
                                                <span className="badge bg-success-subtle text-success">
                                                    ${payment.amount_paid?.toFixed(2)} {payment.method && `via ${payment.method}`}
                                                </span>

                                                <strong className="ms-3">💳 Payment Status:</strong>{" "}
                                                <span className={`badge ${badgeClass}`}>{status}</span>

                                                <div className="text-muted small">On {parseDate(payment.payment_date)}</div>
                                            </div>
                                        </li>
                                    );
                                })}

                                {/* ✅ Installation Status Logs */}
                                {statusHistory?.map((log, idx) => (
                                    <li key={`status-${idx}`}>
                                        <div>
                                            <strong>📦 Installation Status:</strong>{" "}
                                            <span className="badge bg-secondary-subtle text-dark">
                                                {
                                                    log.from === null && resolveOrderStatus(log.from)
                                                }
                                                {resolveOrderStatus(log.from)} → {resolveOrderStatus(log.to)}
                                            </span>
                                            <div className="text-muted small">On {parseDate(log.timestamp)}</div>
                                            {log.note && <div className="small mt-1">📝 {log.reason}</div>}
                                        </div>
                                    </li>
                                ))}

                            </ul>
                        </div>
                    </div>

                    {(showAllocateModal || showViewInventoryModal) && (
                        <div className="modal-backdrop show"></div>
                    )}
                    <div className={`modal fade ${showAllocateModal ? "show d-block" : ""}`} tabIndex={-1} role="dialog">
                        <div className="modal-dialog modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Allocate Rotational Product </h5>
                                    <button type="button" className="btn-close" onClick={() => setShowAllocateModal(false)}></button>
                                </div>
                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label htmlFor="">Select Product:</label>
                                        </div>
                                        <div className="col-md-8">
                                            <Select
                                                name="productId"
                                                id="productId"
                                                options={rotationalproductOptions}
                                                value={selectedProduct}
                                                onChange={handleProductSelect}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label htmlFor="">Select Warehouse:</label>
                                        </div>
                                        <div className="col-md-8">
                                            <Select
                                                name="warehouseId"
                                                id="warehouseId"
                                                options={warehouseOptions}
                                                value={selectedWarehouse}
                                                onChange={(selected) => {
                                                    setSelectedWarehouse(selected);
                                                    if (selectedProduct?.fullProduct && selected?.value) {
                                                        const rotationalId = selectedProduct.value;
                                                        const warehouseId = selected.value;
                                                        fetchSerializedUnits(rotationalId, warehouseId);
                                                    }
                                                }}
                                            />


                                            {/* <select className="form-control">
                            <option value="warehouse A">Warehouse A</option>
                            <option value="warehouse B">Warehouse B</option>
                          </select> */}
                                        </div>
                                    </div>
                                    {/* <p><strong>Quantity Required:</strong> 3</p> */}

                                    {/** ✅ Check if this linked product already has one allocation */}
                                    {/* {(() => {
                        const hasAllocationForLinkedProduct = !!(linkedProductIdContext && allocatedUnits[linkedProductIdContext]);
    
                        return (
                          <table className="table table-bordered default-table">
                            <thead>
                              <tr>
                                <th>Serial No.</th>
                                <th>Warehouse</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {availableSerializedUnits?.length === 0 ? (
                                <tr>
                                  <td colSpan={3} className="text-center">No units available</td>
                                </tr>
                              ) : (
                                availableSerializedUnits?.map((unit, idx) => (
                                  <tr key={unit.serial_id || idx}>
                                    <td>{unit.serial_number || "N/A"}</td>
                                    <td>{unit.warehouse_name}</td>
                                    <td>
                                      <button
                                        className="btn btn-sm btn-success"
                                        disabled={hasAllocationForLinkedProduct}
                                        onClick={() => {
                                          if (!linkedProductIdContext || !selectedProduct || !selectedWarehouse) return;
    
                                          const linkedProductId = linkedProductIdContext;
                                          const rotationalProductId = selectedProduct.value;
                                          const warehouseId = selectedWarehouse.value;
    
                                          const newUnit = {
                                            rotationalProductId,
                                            warehouseId,
                                            serial_id: unit.serial_id,
                                            serial_number: unit.serial_number,
                                          };
    
                                          setAllocatedUnits((prev) => {
                                            const existing = prev[linkedProductId] || [];
                                            const alreadyExists = existing.some(u => u.serial_id === unit.serial_id);
                                            if (alreadyExists) {
                                              toast.warning("This unit is already allocated.");
                                              return prev;
                                            }
                                            return {
                                              ...prev,
                                              [linkedProductId]: [...existing, newUnit],
                                            };
                                          });
    
                                          toast.success("Unit allocated.");
                                        }}
                                      >
                                        Allocate
                                      </button>
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </table>
                        );
                      })()} */}

                                    {linkedProductIdContext && (
                                        <>
                                            {/** ✅ Check if this linked product already has one allocation */}
                                            {(() => {
                                                const linkedProduct = selectedProducts.find(p => p.product_id === linkedProductIdContext);
                                                const quantityRequired = linkedProduct?.quantity || 0;
                                                const allocatedForLinkedProduct = allocatedUnits[linkedProductIdContext] || [];

                                                const remainingQuantity = Math.max(quantityRequired - allocatedForLinkedProduct.length, 0);
                                                // const hasAllocationForLinkedProduct = !!(linkedProductIdContext && allocatedUnits[linkedProductIdContext]);

                                                return (
                                                    <>
                                                        <p>
                                                            <strong>Quantity Required:</strong> {quantityRequired} <br />
                                                            <strong>Remaining:</strong> {remainingQuantity}
                                                        </p>
                                                        <table className="table table-bordered default-table">
                                                            <thead>
                                                                <tr>
                                                                    <th>Serial No.</th>
                                                                    <th>Warehouse</th>
                                                                    <th>Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {availableSerializedUnits?.length === 0 ? (
                                                                    <tr>
                                                                        <td colSpan={3} className="text-center">No units available</td>
                                                                    </tr>
                                                                ) : (
                                                                    availableSerializedUnits?.map((unit, idx) => {
                                                                        const isAlreadyAllocated = allocatedForLinkedProduct.some(u => u.serial_id === unit.serial_id);
                                                                        const disableAllocate = isAlreadyAllocated || remainingQuantity <= 0;
                                                                        return (
                                                                            <tr key={unit.serial_id || idx}>
                                                                                <td>{unit.serial_number || "N/A"}</td>
                                                                                <td>{unit.warehouse_name}</td>
                                                                                <td>
                                                                                    <button
                                                                                        className="btn btn-sm btn-success"
                                                                                        disabled={disableAllocate}

                                                                                        onClick={async () => {
                                                                                            if (!linkedProductIdContext || !selectedProduct || !selectedWarehouse) return;

                                                                                            const linkedProductId = linkedProductIdContext;
                                                                                            const rotationalProductId = selectedProduct.value;
                                                                                            const warehouseId = selectedWarehouse.value;
                                                                                            const success = await allocateSerialUnit({
                                                                                                rotationalProductId: selectedProduct.value,
                                                                                                warehouseId: selectedWarehouse.value,
                                                                                                serialId: unit.serial_id,
                                                                                            });


                                                                                            const newUnit = {
                                                                                                rotationalProductId,
                                                                                                warehouseId,
                                                                                                serial_id: unit.serial_id,
                                                                                                serial_number: unit.serial_number,
                                                                                                product_name: selectedProduct?.label || "",
                                                                                                sku: selectedProduct?.sku || "",
                                                                                            };

                                                                                            setAllocatedUnits((prev) => {
                                                                                                const existing = prev[linkedProductId] || [];
                                                                                                const alreadyExists = existing.some(u => u.serial_id === unit.serial_id);
                                                                                                if (alreadyExists || existing.length >= quantityRequired) {
                                                                                                    toast.warning("You can't allocate more than the required quantity.");
                                                                                                    return prev;
                                                                                                }
                                                                                                return {
                                                                                                    ...prev,
                                                                                                    [linkedProductId]: [...existing, newUnit],
                                                                                                };
                                                                                            });

                                                                                            toast.success("Unit allocated.");
                                                                                        }}
                                                                                    >
                                                                                        Allocate
                                                                                    </button>

                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </>
                                                );
                                            })()}
                                        </>
                                    )}

                                </div>
                            </div>
                        </div>
                    </div>

                    {(showAllocateModal || showViewInventoryModal) && (
                        <div className="modal-backdrop show"></div>
                    )}

                    <div className={`modal fade ${showViewInventoryModal ? "show d-block" : ""}`} tabIndex={-1} role="dialog">
                        <div className="modal-dialog modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Non-Rotational Product Inventory</h5>
                                    <button type="button" className="btn-close" onClick={() => setShowViewInventoryModal(false)}></button>
                                </div>
                                <div className="modal-body">
                                    <p>Product: Panel XYZ</p>
                                    <table className="table table-bordered default-table">
                                        <tr>
                                            <th>Warehouse </th>
                                            <th>In Storage</th>
                                            <th>Reserved</th>
                                            <th>On Site </th>
                                        </tr>
                                        <tr>
                                            <td>Warehouse A </td>
                                            <td>50 </td>
                                            <td>10 </td>
                                            <td>5</td>
                                        </tr>
                                        <tr>
                                            <td>Warehouse B </td>
                                            <td>30 </td>
                                            <td>5 </td>
                                            <td>2</td>
                                        </tr>
                                    </table>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </div >
    );
};

export default SignageTeammemberViewInstallation;
